import { forwardRef } from 'react'

import { useTabsContext } from './context'

interface PanelProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children' | 'className'> {
  children: React.ReactNode | (({ isActive }: { isActive: boolean }) => React.ReactNode);
  name: string;
}

export const Panel = forwardRef<HTMLDivElement, PanelProps>(
  ({ children, name, ...props }, forwardedRef) => {
    const { activeTab, rootId } = useTabsContext()
    const isActive = activeTab === name

    const tabId = `${rootId}-${name}-tab`
    const panelId = `${rootId}-${name}-panel`

    return (
      <div
        {...props}
        aria-labelledby={tabId}
        className='peer-[]/tab-list:mt-6 outline outline-2 outline-offset-2 outline-transparent focus-visible:outline-thatch-500'
        id={panelId}
        hidden={!isActive}
        ref={forwardedRef}
        role='tabpanel'
        tabIndex={isActive ? 0 : -1}
      >
        {typeof children === 'function' ? children({ isActive }) : children}
      </div>
    )
  }
)

Panel.displayName = 'Tabs.Panel'
